import { AppThunk } from 'store/rootStore';

import { setInspirationsCurrentStep } from '../../config/actions';

export const configureSocialPostBuilderThunk = (): AppThunk<void> => async dispatch => {
  dispatch(setInspirationsCurrentStep(undefined));
};
